import React from "react";
import styled from "styled-components";


const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
    padding: 2rem;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    text-align: center;
    border: solid 1px #000;
    border-radius: 4px;
`;

const FreeBoard = () => {
    return (
        <Wrapper>
            자유게시판 페이지 입니다.
        </Wrapper>
    );
};

export default FreeBoard;
